import tasks from './tasks.store'
import customersTasks from './customers-tasks.store'
import customerMachineries from './customer-machineries.store'
import trackings from './trackings.store'
import machineries from './machineries.store'
import customers from './customers.store'
import tractors from './tractors.store'
import campaigns from './campaigns.store'
import machineryTypes from './machinery-types.store'
import brands from './brands.store'
import users from './users.store'
import activities from './activities.store'
import opportunities from './opportunities.store'
import notes from './notes.store'
import customerGroups from './customer-groups'
import messages from './messages.store'
import campaignContents from './campaign-contents.store'
import profile from './profile.store'
import dealerGoals from './dealer-goals.store'
import branchGoals from './branch-goals.store'
import zoneGoals from './zone-goals.store'
import sellerGoals from './seller-goals.store'
import dealers from './dealers.store'
import branches from './branches.store'
import zones from './zones.store'
import customerActivities from './customer-activities.store'
import sellers from './sellers.store'
import dash from './dash.store'
import app from './app.store'
import campaignComments from './campaign-comments.store'
import assignedGoals from './assigned-goals'

export default {
  machineryTypes,
  brands,
  tasks,
  customersTasks,
  customerMachineries,
  customerActivities,
  trackings,
  machineries,
  tractors,
  customers,
  campaigns,
  activities,
  users,
  opportunities,
  notes,
  customerGroups,
  messages,
  campaignContents,
  profile,
  dealerGoals,
  branchGoals,
  sellerGoals,
  zoneGoals,
  dealers,
  branches,
  sellers,
  zones,
  dash,
  app,
  campaignComments,
  assignedGoals
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js